import type * as React from 'react';
const SvgIcoShape = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 14.904h6v6H4zM17.5 21.404a3.5 3.5 0 0 1-3.5-3.5v0a3.5 3.5 0 0 1 3.5-3.5v0a3.5 3.5 0 0 1 3.5 3.5v0a3.5 3.5 0 0 1-3.5 3.5M12 3.404l-4.375 7h8.75z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcoShape;
